module.exports = __webpack_public_path__ + "img/ic_insurance_large.0312a37.svg";